import { render, staticRenderFns } from "./QuestionView.vue?vue&type=template&id=6218cc3e"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"
import style0 from "./QuestionView.vue?vue&type=style&index=0&id=6218cc3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports